var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.59961 8.4001C1.59961 7.73736 2.13687 7.2001 2.79961 7.2001C3.46235 7.2001 3.99961 7.73736 3.99961 8.4001V13.2001C3.99961 13.8628 3.46235 14.4001 2.79961 14.4001C2.13687 14.4001 1.59961 13.8628 1.59961 13.2001V8.4001Z",
    fill: "#9CA3AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79961 8.26676V12.6112C4.79961 13.2173 5.14201 13.7713 5.68407 14.0423L5.72394 14.0623C6.16828 14.2844 6.65824 14.4001 7.15503 14.4001H11.4879C12.2506 14.4001 12.9073 13.8618 13.0569 13.1139L14.0169 8.31388C14.2149 7.32382 13.4576 6.4001 12.4479 6.4001H9.59961V3.2001C9.59961 2.31644 8.88326 1.6001 7.99961 1.6001C7.55778 1.6001 7.19961 1.95827 7.19961 2.4001V2.93343C7.19961 3.62582 6.97504 4.29952 6.55961 4.85343L5.43961 6.34676C5.02418 6.90067 4.79961 7.57438 4.79961 8.26676Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.99aa939fcb80e2c23b510cc3c736db34.svg";
export { ForwardRef as ReactComponent };